"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmSiteSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.CrmSiteSchema = {
    name: 'crm-site',
    alias: 'CRM Site',
    shortName: 'Site',
    applications: ['aap'],
    // crm-service creates this index with its own mapping and writes every document itself. The
    // search-sync migration would replace that mapping with one derived from this schema, which
    // breaks the service's org filter and substring matching.
    disabled: true,
    returnType: {
        aap: transport_types_1.Crm.Site,
    },
    searchableAttributes: [
        {
            field: 'name',
            alias: 'Site Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.addressLine1',
            alias: 'Service Location Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: true,
        },
        {
            field: 'commServices.vendorName',
            alias: 'Vendor Name',
            shortName: 'Vendor',
            searchableByDefault: true,
        },
        {
            field: 'status',
            alias: 'Site Status',
            shortName: 'Status',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'status',
            alias: 'Site Status',
            shortName: 'Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: [
                { value: 'MORE_INFO_NEEDED', label: 'More Info Needed' },
                { value: 'NEEDS_REVIEW', label: 'Needs Review' },
                { value: 'READY_TO_QUOTE', label: 'Ready To Quote' },
                { value: 'QUOTED', label: 'Quoted' },
                { value: 'LOA', label: 'LOA' },
                { value: 'PROPOSED', label: 'Proposed' },
                { value: 'SUBSCRIPTION', label: 'Subscription' },
                { value: 'PARTIALLY_WON', label: 'Partially Won' },
                { value: 'CLOSED_WON', label: 'Closed - Won' },
                { value: 'CLOSED_LOST', label: 'Closed - Lost' },
                { value: 'PARTIALLY_QUOTED', label: 'Partially Quoted' },
                { value: 'RE_QUOTE', label: 'Re-Quote' },
            ],
            allowsMultipleValues: true,
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            field: 'issues', // Computed field - not in transport type
            alias: 'Has Issue',
            shortName: 'Has Issue',
            type: 'HAS_NESTED',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=crm-site.js.map